import { render } from "./InterfaceUpgrading.vue?vue&type=template&id=3b7698e0&scoped=true"
import script from "./InterfaceUpgrading.vue?vue&type=script&lang=js"
export * from "./InterfaceUpgrading.vue?vue&type=script&lang=js"

import "./InterfaceUpgrading.vue?vue&type=style&index=0&id=3b7698e0&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7698e0"]])

export default __exports__